import React from "react";
import Loadable from "react-loadable";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";

import { queryStringDate } from "../../actions";
import { generateQueryStringFromReduxState, queryString } from "../../utils";
import { AsynLoader } from "../Loader/AsynLoader";
import Modal from "../Modals";

class DateFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: "",
      showModal: false,
      redirect: ""
    };
  }
  componentWillUnmount() {
    window.removeEventListener("mousedown", this.detectClickOutSide);
  }
  componentDidMount() {
    window.addEventListener("mousedown", this.detectClickOutSide);
    const { from, to } = this.props.query.date;
    if (from && to) {
      this.setState({ selectedDate: from + " - " + to });
    } else {
      this.setState({ selectedDate: "Date" });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.query.date !== prevProps.query.date) {
      const { from, to } = this.props.query.date;
      if (from && to) {
        this.setState({ selectedDate: from + " - " + to });
      } else {
        this.setState({ selectedDate: "Date" });
      }
    }
  }

  handleSelect = (startDate, endDate) => {
    let q = generateQueryStringFromReduxState(this.props.query);

    q.from = startDate;
    q.to = endDate;

    this.setState({
      selectedDate: startDate + " - " + endDate,
      showModal: false,
      redirect: "/activity?" + queryString.stringify(q)
    });

    this.props.queryStringDate({ from: startDate, to: endDate });
  };

  handleReset = () => {
    let q = generateQueryStringFromReduxState(this.props.query);

    delete q.from;
    delete q.to;

    this.setState({
      selectedDate: "Date",
      showModal: false,
      redirect: "/activity?" + queryString.stringify(q)
    });

    this.props.queryStringDate({});
  };

  detectClickOutSide = e => {
    if (window.innerWidth > 700)
      if (!this.dateFilter.contains(e.target)) {
        this.setState({ showModal: false });
      }
  };
  handleResetCross = e => {
    e.stopPropagation();
    this.handleReset();
  };
  render() {
    const { active } = this.props;
    return (
      <div className="t-container-fluid" ref={node => (this.dateFilter = node)}>
        {this.state.redirect !== "" && <Redirect to={this.state.redirect} />}
        <div
          className={`filter__buttons__tertiary ${active ? "active" : ""}`}
          onClick={() => this.setState(prev => ({ showModal: !prev.showModal }))}
        >
          <div
            style={{
              maxWidth: "100%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }}
          >
            {this.state.selectedDate !== "" ? this.state.selectedDate : "Date"}
          </div>
          {active && <div className="clear" onClick={this.handleResetCross} />}
        </div>
        {this.state.showModal && (
          <MediaQuery maxWidth={700}>
            {matches => {
              if (matches) {
                return (
                  <Modal close={() => this.setState({ showModal: false })} reset={this.handleReset}>
                    <AsynDateModal
                      handleSelect={this.handleSelect}
                      from={this.props.query.date.from}
                      to={this.props.query.date.to}
                    />
                  </Modal>
                );
              } else {
                return (
                  <AsynDesktopCalender
                    handleSelect={this.handleSelect}
                    from={this.props.query.date.from}
                    to={this.props.query.date.to}
                    reset={this.handleReset}
                  />
                );
              }
            }}
          </MediaQuery>
        )}
      </div>
    );
  }
}

const AsynDateModal = Loadable({
  loader: () => import("../Modals/DateFilter"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader,
  delay: 0
});

const AsynDesktopCalender = Loadable({
  loader: () => import("./DateSelectDesktop"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader,
  delay: 0
});

const mapStateToProps = state => {
  return {
    query: state.queryString
  };
};
const mapDispatchToProps = dispatch => {
  return {
    queryStringDate: price => dispatch(queryStringDate(price))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DateFilter);
